import * as f from '../../../components/BPMTable/BPMInputs'
import {
    TableFieldDescription, 
    DataMapper, 
} from '../../../components/BPMTable/TableMapperCreator'
import TableCreatorCreator from '../../../components/BPMTable/TableCreatorFactory/TableCreatorCreator'
import tableCreatorCreatorFactoryCreator from '../../../components/BPMTable/TableCreatorFactory/TableCreatorCreatorFactoryCreator'
import { DirectTableQueryBuilder } from '../../../components/BPMTable/TableQueryBuilder/DirectTableQueryBuilder'


const DeviceModelMinimalTableCreatorCreatorQueries = {tableQueryBuilder: new DirectTableQueryBuilder('allDeviceModels')}

class DeviceModelMinimalTableCreatorCreator extends TableCreatorCreator {
    constructor(filters) {
        super(filters)
    }

    static getId = () => {
        return "DeviceModelMinimalTableCreatorCreator"
    }

    getTableCreator = (tableName) => {
        const tableCreator = this.createTableCreator(this.constructor.getId(), tableName, DeviceModelMinimalTableCreatorCreatorQueries)
        tableCreator.addDescriptions([
            new TableFieldDescription(
                'brand',
                new DataMapper("brand.name"),
                new f.FilterDescription(new f.TextFilter("brand")),
                {label: 'Brand'}
            ),
            new TableFieldDescription(
                'model',
                new DataMapper("name"),
                new f.FilterDescription(new f.TextFilter("model")),
                {label: 'Model'}
            ),
            new TableFieldDescription(
                'serviceType',
                new DataMapper("serviceType.name"),
                new f.FilterDescription(new f.TextFilter("serviceType")),
                {label: 'Service Type'}
            )
        ])
        
        return tableCreator;
    }
}

tableCreatorCreatorFactoryCreator.addTableCreatorCreator(DeviceModelMinimalTableCreatorCreator)

export default DeviceModelMinimalTableCreatorCreator